var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToTuUrzadzenie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.9 577.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #127590;\n        stroke: #127590;\n        stroke-miterlimit: 10;\n        stroke-width: 11px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.4,321.2v155.5c0,8.5-9,22.1-19.1,35.4v-151.4c0-2-.2-4-.7-6l-46.9-269.6c-2.2-9.5-10.6-16.2-20.4-16.2l-130.7-4.2c-5.6,0-10.8,2.2-14.6,5.9-1,.9-2.6,0-2.3-1.3l10-48.3c2-9.1,10-15.5,19.3-15.5l149.6,3.9c9.2,0,17.2,6.4,19.3,15.3l36,290.8c.4,1.9.6,3.8.6,5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.5,391.5v155.5c0,13.8-11.2,25-25,25l-213.9-8.3c-13.8,0-25-11.2-25-25v-158.1c0-1.8.2-3.6.6-5.4L62.3,127.4c2-9.1,10-15.5,19.3-15.5l123.5,3.9c9.2,0,17.2,6.3,19.3,15.3l44.3,254.7c.4,1.9.6,3.8.6,5.6h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTuUrzadzenie);
export default __webpack_public_path__ + "static/media/ToTuUrzadzenie.91eadeb7a1af373f8d51e7d557ed2569.svg";
export { ForwardRef as ReactComponent };